import { useId } from "react";

const FIELD_NAMES = [
	"poNumber",
	"loadDate",
	"deliveryDate",
	"needHelpWithSalvage",
	"salvageAmount",
	"estimatedClaimAmount",
	"actualClaimAmount",
	"claimReason",
	"tempRecorder",
	"fedInspection",
	"claimExceedPayAmount",
	"contactName",
	"contactEmail",
	"contactPhone",
	"contactExtension",
	"claimDetails",
] as const;

type ClaimsFieldName = (typeof FIELD_NAMES)[number];

/**
 * Generates stable, unique element ids for the claims form fields so labels can
 * be associated with their controls. Ids are derived from a single `useId` base,
 * keeping them collision-safe across multiple modal instances.
 */
export const useClaimsFieldIds = (): Record<ClaimsFieldName, string> => {
	const baseId = useId();
	return Object.fromEntries(
		FIELD_NAMES.map((name) => [name, `${baseId}-${name}`]),
	) as Record<ClaimsFieldName, string>;
};
